import { useAppDispatch, useAppSelector } from '@/store/hooks';
import { fetchAvailableInstances, fetchSolutions } from '@/store/slices/integrations';
import { getWorkingProjectUuid } from '@/store/slices/project/selectors';
import { getActiveChannel } from '@/store/slices/user/selectors';
import { useEffect, useRef } from 'react';

const useLoadIntegrations = () => {
  const channel = useAppSelector(getActiveChannel);
  const workingProjectUuid = useAppSelector(getWorkingProjectUuid);

  const dispatch = useAppDispatch();

  const fetched = useRef(false);

  useEffect(() => {
    if (!channel || fetched.current || !workingProjectUuid) return;
    fetched.current = true;
    dispatch(fetchAvailableInstances({ channel, workingProjectUuid: workingProjectUuid }));
    dispatch(fetchSolutions({ channel }));
  }, [channel, dispatch, workingProjectUuid]);
};

export default useLoadIntegrations;
